var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewOnAgentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.5225C0 5.15879 5.15879 0 11.5225 0C17.8862 0 23.0449 5.15879 23.0449 11.5225C23.0449 17.8862 17.8862 23.0449 11.5225 23.0449C5.15879 23.0449 0 17.8862 0 11.5225ZM11.8699 14.3979L5.76123 8.28923L7.32907 6.72139L11.8898 11.2821L16.4471 6.72139L18.015 8.28923L11.9096 14.3979H17.4901V16.6168H5.76121V14.3979H11.8699Z",
    fill: "#5A52C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewOnAgentIcon);
export default __webpack_public_path__ + "static/media/viewOnAgentIcon.da20b765668d655602ae3e01ded3e437.svg";
export { ForwardRef as ReactComponent };